// extracted by mini-css-extract-plugin
module.exports = {"SystemMessage":"SystemMessage_SystemMessage__1zg-_"};